var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ugo-list"},[_vm._l((_vm.value),function(item,index){return [_c('a',{key:`_item_${item.id}${index}`,on:{"click":function($event){return _vm.$emit('on-click',item)}}},[_c(item.component || _vm.component,_vm._b({tag:"component"},'component',item,false))],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }